import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: {
    isOpen: boolean;
} = {
    isOpen: false
};

const chatState = createSlice({
    name: 'chatState',
    initialState,
    reducers: {
        setChatOpen: (state, action: PayloadAction<boolean>) => {
            state.isOpen = action.payload;
        }
    }
});

export const { setChatOpen } = chatState.actions;
export default chatState;
